import * as React from "react";
const SvgFiRrGalaxyStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-galaxy-star_svg__a)">
      <path
        fill="#062147"
        d="M21 20.502a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3 0M1.5 3.002a1.5 1.5 0 1 0-.002 2.999A1.5 1.5 0 0 0 1.5 3.002m5-3a1.5 1.5 0 1 0-.002 2.999A1.5 1.5 0 0 0 6.5.002M23 9a1 1 0 0 1 .645 1.764l-2.365 1.927.978 2.98a1 1 0 0 1-1.495 1.153l-2.753-1.793-2.708 1.813a1 1 0 0 1-1.511-1.13l.94-3.015-2.377-1.934A.999.999 0 0 1 13 9.003H16l1.062-2.852a1.001 1.001 0 0 1 1.874 0l1.062 2.852h3L23 9.001m-15.351.204q.372-.396.764-.789c5.55-5.549 11.308-7.528 13.004-5.83.6.6.742 1.744.399 3.223a1 1 0 1 0 1.949.451c.646-2.788-.15-4.306-.933-5.089C19.98-1.682 13.175.826 7 7.001q-.415.416-.81.835A1 1 0 0 0 7.65 9.204m5.569 11.064a1 1 0 0 0-1.186-1.611c-4.076 3.001-8.05 4.163-9.451 2.763-.593-.593-.628-1.586-.553-2.314a1 1 0 0 0-.892-1.098 1.01 1.01 0 0 0-1.097.893c-.171 1.664.219 3.024 1.128 3.934.776.776 1.865 1.155 3.174 1.155 2.409 0 5.562-1.282 8.876-3.72zm-5.795-7.402-1.9-.7-.724-1.924a.844.844 0 0 0-1.601 0l-.717 1.906-1.905.718a.844.844 0 0 0 0 1.601l1.923.724.699 1.898a.844.844 0 0 0 1.6 0l.708-1.916 1.918-.706a.844.844 0 0 0-.001-1.6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-galaxy-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGalaxyStar;
